/**
 * Lightweight activity tracking utility.
 * Sends events to /api/activity/track silently (never throws).
 */
const API = process.env.REACT_APP_BACKEND_URL;

export function trackEvent(token, event, details = {}) {
  if (!token || !event) return;
  fetch(`${API}/api/activity/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ event, details }),
  }).catch(() => {}); // Always silent
}
